import { render, staticRenderFns } from "./MyLocation.vue?vue&type=template&id=bceadd52&scoped=true"
import script from "./MyLocation.vue?vue&type=script&lang=js"
export * from "./MyLocation.vue?vue&type=script&lang=js"
import style0 from "./MyLocation.vue?vue&type=style&index=0&id=bceadd52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceadd52",
  null
  
)

export default component.exports